export default __webpack_public_path__ + "static/media/search-alt.72f69a03.png";